<template>
	<div>
    	<v-dialog v-model="buyerQuestionnaire_dialog" transition="dialog-bottom-transition" max-width="83%" scrollable>
			<v-card>
				<v-card-title class="info pewter--text d-flex justify-space-between">
					<div class="justify-start mr-12">{{ thisBuyer.buyer_fullname }}</div>
					<div class="d-flex flex-grow-1">
						<div class="justify-start mr-6">{{ thisBuyer.email }}</div>
						<v-divider v-if="thisBuyer.phone" vertical class="pewter"></v-divider>
						<div class="justify-center mx-6">{{ thisBuyer.phone }}</div>
						<v-divider v-if="thisBuyer.location_text" vertical class="pewter"></v-divider>
						<div class="justify-end ml-6">{{ thisBuyer.location_text }}</div>
					</div>
					<div class="justify-end">
						<v-btn icon dark class="ml-3" @click="buyerQuestionnaire_dialog = false">
						<v-icon color="pewter">mdi-close</v-icon>
						</v-btn>
					</div>
				</v-card-title>
				<v-card-text>
					<BuyerQuestionnaire 
						:user_id="thisBuyer.buyer_id" 
						:is_secondary="thisBuyer.is_secondary"
						:project_id="thisBuyer.project_id" 
						:module_key="thisBuyer.module_key" 
						:module_id="thisBuyer.module_id"
						:isOpen="buyerQuestionnaire_dialog"
						:openQuestionnaire="openQuestionnaire" />
				</v-card-text>
				<v-card-actions class="info">
					<v-spacer></v-spacer>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-navigation-drawer
            v-model="fileUploadDialog"
            app
            relative
            right
            width="46%"
            overlay-opacity="0"
            class="drawer-shadow">
            <v-card tile class="drawer-content pb-12">
                <v-card-title class="sansation_subtitle primary lighten-2 info--text font-weight-bold py-6 d-flex justify-space-between">
                    <div class="d-inline">
                        Upload Resolution Deliverables
                    </div>
                    <div class="d-inline">
                        <v-btn 
                            icon
                            outlined
                            color="info"
                            elevation="1"
                            @click="closeUploadDeliverables">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-card-title>
                <v-card-text class="pt-3">
                    <UploadResolutionDeliverables 
                        :projectData="projectDetails"
                        :moduleKey="projectDetails.modinfo.module_key"
						:resolutionId="resolutionId"
                        :parentProjectId="projectDetails.project_id"
                        :userId="projectDetails.user_id"
                        :isDeliverable="true"
						@pullProjectDelivs="pullProjectDelivs"
                        @triggerUserFeedback="uploadFeedback"
                        @closeUploadDeliverables="closeUploadDeliverables"
                    />
                </v-card-text>
            </v-card>
        </v-navigation-drawer>

		<v-navigation-drawer
            v-model="resolutionDrawer"
            temporary
            absolute
            right
            width="46%"
            overlay-opacity="0"
            class="drawer-shadow">
            <v-card flat class="drawer-content">
                <v-card-title class="sansation_subtitle primary lighten-2 info--text font-weight-bold py-6 d-flex justify-space-between">
                    <div class="d-inline">
                        Resolution Submission
                    </div>
                    <div class="d-inline">
                        <v-btn 
                            icon
                            outlined
                            color="info"
                            elevation="1"
                            @click="closeNavigationDrawer()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </div>
                </v-card-title>
                
                <v-card-text class="mt-8">
                    <!-- <ResolutionSubmission 
						:resolutionData="resolutionData"
						:projectData="projectDetails"
						:moduleKey="projectDetails.modinfo.module_key"
						:resolutionId="resolutionId"
						:parentProjectId="projectDetails.project_id"
						:userId="projectDetails.user_id"
						:projectStatuses="projectStatuses"
						:calculateResolutionsUsed="calculateResolutionsUsed"
						@closeNavigationDrawer="closeNavigationDrawer"
						@closeUploadDeliverables="closeUploadDeliverables"
						@changeStatus="changeStatus"
						@updateResolutionStatus="updateResolutionStatus"
						@getResolutionCount="getResolutionCount"
						@uploadResolutionDeliverables="uploadResolutionDeliverables"
						@exportAnswers="exportAnswers"
						@buyerQuestionnaire="buyerQuestionnaire"
						@closeQuestionnaire="closeQuestionnaire"
						@triggerUserFeedback="uploadFeedback" /> -->
                </v-card-text>
            </v-card>
        </v-navigation-drawer>

		<v-menu
            v-model="showStatusMenu"
            :position-x="statusMenuPosition.x"
            :position-y="statusMenuPosition.y"
            absolute
            offset-y
        >
            <v-list>
                <v-list-item
                    v-for="(option, index) in projectStatuses"
                    :key="index"
                    :class="option.status_menu_color"
                    ripple
                    @click="changeStatus(selectedStatusItem, option.value)"
                >
                    <v-list-item-title
                        :style="`color: ${['closed','cloned'].includes(option.value) ? 'lightgray' : 'inherit'}; cursor:pointer;`"
                    >
                        {{ option.internal_label }}
                    </v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>

		<v-data-table 
            :items="subProjects" 
            :headers="headers" 
            class="ma-0 pa-0"
            multi-sort>
            
            <template v-slot:item="{ item }">
                <tr>
                    <td class="text-left">
						{{ formatDateTime(item.date_initialized) }}
					</td>
                    <td class="text-left">
                        <div class="d-flex align-center">
                            <div class="d-inline font-weight-bold" 
                                :class="getStatusMetaData(item.status).status_text_color"
                                style="width: 50%">
								<v-chip 
									small
									label
									:color="getStatusMetaData(item.status).status_progress_color"
									text-color="white"
									class="mr-1"
									style="padding: .25rem .4rem !important">
									<span class="font-weight-bold">
										{{ getStatusMetaData(item.status).internal_label }}
									</span>
									<v-icon v-if="item.is_archived" small class="ml-1">mdi-archive-alert</v-icon>
								</v-chip>
                            </div>

                            <div class="d-inline" style="width: 50%">
                                <v-btn
                                    v-if="item.status != 'complete'"
                                    x-small
                                    class="mx-2 elevation-1"
                                    fab
                                    color="primary darken-1"
                                    @click.stop="openStatusMenu($event, item)">
                                    <v-icon>mdi-palette-swatch-variant</v-icon>
                                </v-btn>
                            </div>
                        </div>
                    </td>

                    <td class="text-left">
						{{ item.date_submitted ? formatDateTime(item.date_submitted) : 'N/A' }}
                    </td>
                    <td class="text-center">
                        {{ getResolutionCount(item.resolutions_data) }}
                    </td>

                    <td class="text-right">
						{{ item.close_date ? item.status != 'complete' ? 'est. ' + formatDateTime(item.close_date) : formatDateTime(item.close_date) : 'N/A' }}
                    </td>
                    
                    <td class="text-right">
                        <div v-for="doc in projectDetails.dlvs.filter(file => file.question === item.project_id)" 
							:key="doc.file_id" 
							class="pb-1 d-block">
                            <a :href="doc.url" target="_blank">{{ doc.file_name }}</a>
                        </div>
                    </td>

                    <td class="text-right">
		                <div class="d-flex justify-end">
							<v-tooltip top content-class="contact_tooltip">
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										fab
										x-small
										color="primary darken-1"
										class="elevation-1 mr-1"
										v-bind="attrs"
										v-on="on"
										@click.stop.prevent="uploadResolutionDeliverables(item)">
										<v-icon>mdi-cloud-upload</v-icon>
									</v-btn>
								</template>
								Upload Deliverables
							</v-tooltip>
							
							<v-tooltip top content-class="contact_tooltip">
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										v-if="item.has_data"
										fab
										x-small
										color="primary darken-1"
										class="elevation-1 mr-1"
										v-bind="attrs"
										v-on="on"
										@click.stop.prevent="buyerQuestionnaire(item)">
										<v-icon>mdi-view-day-outline</v-icon>
									</v-btn>
								</template>
								View Questionnaire
							</v-tooltip>

							<v-tooltip top content-class="contact_tooltip">
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										v-if="item.has_data"
										fab
										x-small
										color="primary darken-1"
										class="elevation-1"
										v-bind="attrs"
										v-on="on"
										:loading="!!exportingAnswersByProject[item.project_id]"
										:disabled="!!exportingAnswersByProject[item.project_id]"
										@click.stop.prevent="exportAnswers(item)">
										<v-icon>mdi-file-export</v-icon>
									</v-btn>
								</template>
								Export Answers
							</v-tooltip>

							<v-tooltip top content-class="contact_tooltip">
								<template v-slot:activator="{ on, attrs }">
									<v-btn 
										v-if="!item.has_data"
										fab
										x-small
										disabled
										color="general_grey"
										class="elevation-1"
										v-bind="attrs"
										v-on="on">
										<v-icon>mdi-file-export</v-icon>
									</v-btn>
								</template>
								No Data
							</v-tooltip>
						</div>
                    </td>
                </tr>
            </template>
        </v-data-table>
	</div>
</template>

<script>
	import axios from "axios";
	import Cookie from 'js-cookie';
	import appUrls from '../helpers/environment'

	import BuyerQuestionnaire from './ModuleQuestionnaire'
	import UploadResolutionDeliverables from './UploadResolutionDeliverables'
	// import ResolutionSubmission from './ResolutionSubmission'


	export default {
		name: 'ProjectResolutions',

		components: {
			BuyerQuestionnaire,
			UploadResolutionDeliverables,
			// ResolutionSubmission
		},

		props: {
			projectDetails: Object,
			subProjects: Array,
			pullProjectDelivs: Function,
			getSubProjects: Function,
			calculateResolutionsUsed: Number,
			projectStatuses: Array,
			formatThisDate: Function,
			openQuestionnaire: Function,
			triggerUserFeedback: Function,
		},

		data() {
			return {
				headers: [
					{ text: 'Date Started', 	value: 'date_initialized', 	align: 'start',  sortable: true },
					{ text: 'Status', 			value: 'status', 			align: 'start',  sortable: true },
					{ text: 'Date Submitted', 	value: 'date_submitted',	align: 'start',  sortable: true },
					{ text: 'Resolution Count', value: 'resolution_data', 	align: 'center', sortable: false },
					{ text: 'Completion Date', 	value: 'close_date', 		align: 'end', 	 sortable: true },
					{ text: 'Uploads', 			value: '', 					align: 'end', 	 sortable: false },
					{ text: 'Actions',			value: '', 					align: 'end', 	 sortable: false },
				],
				buyerQuestionnaire_dialog: false,
				thisBuyer: {},
				resolutionDrawer: false,
				showStatusMenu: false,
				statusMenuPosition: { x: 0, y: 0 },
				selectedStatusItem: null,
				fileUploadDialog: false,
				resolutionId: null,
				resolutionData: {},
				exportingAnswersByProject: {},
			}
		},

		methods: {
			formatDateTime: function ( date_to_format ) {
                const options = {
                    month: '2-digit', 
                    day: '2-digit', 
                    year: 'numeric'
                }

                const formatted_date = this.formatThisDate(date_to_format, options);
                return formatted_date ? formatted_date : '';
            },

			uploadFeedback ( show_feedback, message ) {
				this.$emit('triggerUserFeedback', show_feedback, message);
			},

			openResolutionDrawer ( item ) {
				this.resolutionData = item
				this.resolutionDrawer = true
			},

			closeNavigationDrawer () {
				this.resolutionDrawer = false
			},

			openStatusMenu ( event, item ) {
				this.selectedStatusItem = item
				this.statusMenuPosition.x = event.clientX
				this.statusMenuPosition.y = event.clientY
				this.showStatusMenu = true
			},

			getStatusMetaData: function ( status_val ) {
				return this.projectStatuses.find( status => status.value == status_val ) ? this.projectStatuses.find( status => status.value == status_val ) : {}
			},

			closeUploadDeliverables: function () {
				this.fileUploadDialog = false 
			},

			changeStatus: async function (item, selectedStatusOption) {
				if (!item) {
					this.showStatusMenu = false
					return
				}

				if (item.status == selectedStatusOption) {
					this.showStatusMenu = false
					this.selectedStatusItem = null
					this.$emit('triggerUserFeedback', true, 'This project\'s status is already set to this option.', 'accent' );
					return
				}

				this.projectStatuses.find(status => {
					if (status.value == selectedStatusOption) {
						item.status 				= status.value
						item.status_internal_label 	= status.internal_label
						item.status_color 			= status.status_color
						item.status_progress_color 	= status.status_progress_color
						item.status_text_color 		= status.status_text_color
					}
				})

				this.updateResolutionStatus( item, selectedStatusOption )
				this.showStatusMenu = false
				this.selectedStatusItem = null
				this.$emit('triggerUserFeedback', true, 'Project status updated successfully.');
				this.$emit('getSubProjects', this.projectDetails.project_id)
			},

			updateResolutionStatus: async function ( resolution, new_status = 'complete' ) {
				const project = { ...resolution }
				project.status = new_status

				const update_project_status_rs = await axios.put(`${appUrls.api}/api/admin/update_project_status`, {
					headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
					project
				})

				if ( update_project_status_rs.data.outcome ) {
					resolution.close_date = update_project_status_rs.data.project.close_date
					this.$emit('triggerUserFeedback', true, update_project_status_rs.data.message);
				} else {
					this.$emit('triggerUserFeedback', true, "There was a problem during the process of completing the resolution for this project.", 'accent' );
				}
			},

			getResolutionCount: function ( resolutions_data ) {
				const this_resolutions_count = resolutions_data ? Object.keys(resolutions_data).filter( key => resolutions_data[key] == 'true' ).length : 0

				return `${this_resolutions_count} / ${this.calculateResolutionsUsed}`
			},

			uploadResolutionDeliverables: function ( item ) {
				this.resolutionId = item.project_id
				this.fileUploadDialog = true
			},

			exportAnswers: async function ( projectDetails ) {
				const projectId = projectDetails.project_id
				this.$set(this.exportingAnswersByProject, projectId, true)
				
				try {	
					const export_questionnaire = await axios.post(`${appUrls.api}/api/admin/export_data`, {
						headers: { authentication: Cookie.get('token'), "Content-Type": "application/json" },
						moduleKey: projectDetails.module_key,
						projectId: projectDetails.project_id,
						userId: projectDetails.user_id,
						parentProjectId: projectDetails.parent_project_id
					})
				
					if (export_questionnaire.data.outcome) {
						this.$feedback.success( export_questionnaire.data.message );

						const this_fileData = Buffer.from(export_questionnaire.data.buf, 'base64');
						const this_fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
						const this_fileName = export_questionnaire.data.basic_data.file_name + '.' + export_questionnaire.data.basic_data.output_type;

						const this_blob = new Blob([this_fileData], { type: this_fileType });
						saveAs(this_blob, this_fileName);
					} else {
						this.$emit('triggerUserFeedback', true, 'There was a problem during the process of exporting the answers for this project.', 'accent');
					}
				} catch (error) {
					console.log(error);
				} finally {
					this.$set(this.exportingAnswersByProject, projectId, false)
				}
			},

			buyerQuestionnaire( buyer ) {
				this.thisBuyer = {}
				this.thisBuyer = buyer;
				this.thisBuyer.buyer_id = buyer.user_id
				this.thisBuyer.is_secondary = false
				this.thisBuyer.project_id = buyer.project_id

				setTimeout(() => {
					this.buyerQuestionnaire_dialog = true;
				}, 1000)
			},

			closeQuestionnaire: function () {
				this.thisBuyer = {}
				this.buyerQuestionnaire_dialog = false;
			}
		},
	}
</script>

<style scoped>
 >>> .v-data-table .v-data-table__wrapper > table > thead > tr > th {
        padding: 0 1em 0 1em !important;
        font-size: x-small !important;
        /* color: #333 !important; */
        margin: 0 !important;
        height: 36px !important;
        /* border-top: 1px solid #EDEDED !important; */
    }
 >>> .v-data-table .v-data-table__wrapper > table > tbody > tr > td {
        padding: .8em 1em .8em 1em !important;
        margin: 0 !important;
        font-size: small !important;
        cursor: pointer !important;
    }
	.drawer-shadow {
        z-index: 2000;
        box-shadow: -6px 0 12px rgba(0, 0, 0, 0.15);
    }
    .drawer-content {
        height: 100%; /* Full height of the drawer */
        overflow-y: auto; /* Allow vertical scrolling */
        background-color: whitesmoke !important;
    }
    /* Hide scrollbar but allow scrolling */
    .drawer-content::-webkit-scrollbar {
        display: none; /* For Chrome, Safari, and Edge */
    }
    .drawer-content {
        -ms-overflow-style: none; /* For Internet Explorer and Edge */
        scrollbar-width: none; /* For Firefox */
    }
	.contact_tooltip {
        font-size: .8rem !important;
        padding: .25rem .8rem !important;
        margin-top: .2rem !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/ProjectResolutions.vue